import { FreeReducedMealAppIncome } from "./free-reduced-meal-app-income.model";

export class FreeReducedMealAppChildIncome extends FreeReducedMealAppIncome {
    ChildID: number;
    ChildIncomeTypeID: number;
   }